<script setup lang="ts">
import type { Anomaly } from '../../composables/useSignalPipeline'
defineProps<{ anomalies: Anomaly[] }>()
</script>

<template>
  <div v-if="anomalies.length" class="rail" data-testid="anomaly-rail">
    <span class="rail-label">Anomalies</span>
    <span v-for="a in anomalies" :key="a.key" class="an-chip" :class="'an-' + a.severity"
          :data-testid="a.testid" :title="a.title">{{ a.label }}</span>
  </div>
</template>

<style scoped>
.rail { display: flex; gap: 6px; align-items: center; flex-wrap: wrap;
  background: #161b22; border: 1px solid #30363d; border-radius: 8px; padding: 6px 12px; }
.rail-label { font-size: .6rem; color: #8b949e; text-transform: uppercase; }
.an-chip { border-radius: 10px; padding: 1px 8px; font-size: .68rem; border: 1px solid; }
.an-error { background: #f8514922; border-color: #f85149; color: #f85149; }
.an-warn { background: #d2992222; border-color: #d29922; color: #d29922; }
.an-info { background: #21262d; border-color: #30363d; color: #8b949e; }
/* benign = expected-state disclosure (e.g. FX pre-strike fallback):
   green so it reads "informational, self-clearing", not actionable. */
.an-benign { background: #23863622; border-color: #238636; color: #3fb950; }
</style>
